export default "__VITE_ASSET__DWhEQE2Y__"